import { GxForm, GxIcon } from '@garpix/garpix-web-components-react'
import React, { useState } from 'react'
import {
  // championshipFinal,
  // championshipStar,
  // championshipTrophy,
  championshipWaiting,
  // medalIcon,
  searchIcon
} from '@/images'
import style from '../styles/tourn_detail.module.scss'
import FiltersButton from './FiltersButton'
import Input from '@/components/Input'
import IconButton from '@/components/Button/IconButton'
import { StateSelect } from '@/components/Select'
import AgeButton from './AgeButton'
import { IChampionship } from '@/interfaces/Championship'
import { STAGE_TYPE } from '../const'
import { Status } from '../types'
import { TypeLoadData } from '@/interfaces/Fetcher'

interface IProps {
  tournament: IChampionship
  handleFilter: TypeLoadData
  initFilters: any
}

const getStatus = (stage, currentStage, isFinish: boolean): Status => {
  // Если финиш, то на все этипы финиш
  if (isFinish) {
    return 'finished'
  }
  if (stage === currentStage) {
    return 'waiting'
  }
  if (stage > currentStage) {
    return 'open'
  }
  if (stage < currentStage) {
    return 'finished'
  }
  return 'open'
}

const Filters = ({ tournament, initFilters, handleFilter }: IProps): React.ReactElement => {
  const initStage: number = Number(tournament?.property_tournament_stage_value ?? '1')

  const [filter, setFilter] = useState({
    id: tournament.id,
    q: '',
    age: '10-14',
    state: '',
    page_size: initFilters.page_size,
    stage: initFilters.stage
  })
  const { stage: selectStage } = filter
  const isFinish = Boolean(Number(tournament?.property_is_finished_value))

  // const isWaiting = Boolean(Number(tournament?.property_tourney_register_closed_value)) && !isFinish
  // const isOpen = !isWaiting && !isFinish

  const handleState = (e): void => {
    const newFiltes = { ...filter, state: e.target.value }
    setFilter(newFiltes)
    handleFilter(1, newFiltes)
  }

  const inputSearch = (e): void => setFilter({ ...filter, q: e.target.value })

  const onSubmit = (): void => handleFilter(1, filter)

  const handleStage = (currentStage): void => {
    const newFiltes = { ...filter, stage: currentStage }
    setFilter(newFiltes)
    handleFilter(1, newFiltes)
  }

  const handleAge = (value): void => {
    const newFiltes = { ...filter, age: value }
    setFilter(newFiltes)
    handleFilter(1, newFiltes)
  }

  return (
    <GxForm onGx-submit={onSubmit}>
      <div className={style.filters}>
        <ul className={style.filters_buttons}>
          {Object.keys(STAGE_TYPE).sort().reverse().map(key => {
            const currentStage = Number(key)
            const el = STAGE_TYPE[key]
            const status = getStatus(initStage, currentStage, isFinish)

            return (
              <li key={key} className={style.filters__button}>
                <FiltersButton
                  status={status}
                  isDisabled={currentStage > initStage}
                  isCurrent={Number(selectStage) === currentStage}
                  onClick={() => handleStage(currentStage)}
                >
                  {/* Если финиш, то ставим обычную иконку */}
                  <GxIcon
                    src={currentStage === initStage && !isFinish ? championshipWaiting : el.icon}
                    className={style.filters__icon}
                  />
                  {el.title}
                </FiltersButton>
              </li>
            )
          })}
        </ul>

        <ul className={style.filters_age}>
          <li className={style.filters_age__item}>
            <AgeButton onClick={() => handleAge('10-14')} checked={filter.age === '10-14'}>10-14 лет</AgeButton>
          </li>
          <li className={style.filters_age__item}>
            <AgeButton onClick={() => handleAge('15-17')} checked={filter.age === '15-17'}>15-17 лет</AgeButton>
          </li>
        </ul>

        <div className={style.filters_row}>
          <Input
            onGx-input={inputSearch}
            type='text'
            theme='secondary'
            placeholder='Поиск...'
            className={style.filters_search}
          >
            <IconButton
              type='submit'
              theme='red'
              size='medium'
              slot='suffix'
              className={style.filters_search__button}
            >
              <GxIcon src={searchIcon} className={style.filters_search__icon} />
            </IconButton>
          </Input>

          <StateSelect
            clearable
            onGx-change={handleState}
            label=''
            theme='secondary'
            placeholder='Выбери регион'
            className={style.filters__state}
          />
        </div>
      </div>
    </GxForm>
  )
}

export default Filters
